import { StreamSource } from "../hooks/streams";
import { CompetitionId, UserId } from "@vote4dance/judging-types";
import {
    CafeOrder,
    CafeProduct
} from "@vote4dance/judging-schema";

export type CafeProductItem = CafeProduct;

export type CafeOrderCustomerRole = 'judge' | 'administrator' | 'manager' | 'speaker' | 'functionary' | 'viewer';

export type CafeOrderItem = CafeOrder
& Pick<CafeProduct, 'product_name' | 'product_price' | 'product_currency'>
& {
    order_customer_role?: CafeOrderCustomerRole;
    customer_firstname?: string;
    customer_lastname?: string;
    claimed_by_firstname?: string;
    claimed_by_lastname?: string;
};

export function CafeCompetitionProductsSource(competition_id: CompetitionId) {
    return new StreamSource<CafeProductItem[]>(`/cafe-products/${competition_id}`);
}

export function CafeCompetitionOrdersSource(competition_id: CompetitionId) {
    return new StreamSource<CafeOrderItem[]>(`/cafe-orders/${competition_id}`);
}

export function CafeCompetitionUserOrdersSource(competition_id: CompetitionId, user_id: UserId) {
    return new StreamSource<CafeOrderItem[]>(`/cafe-orders/${competition_id}/${user_id}`);
}
